import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { readBundledData } from "@faire/retailer-visitor-shared/lib/bundledData";
import { useQuery, getQueryKey, getQueryFn } from "@faire/web-api--source/api/v2/product/productToken/get-hooks";
var FIVE_MINUTES_IN_MS = 1000 * 60 * 5;
export var useLeanProductQuery = function(productToken, options) {
    return useQuery(productToken !== null && productToken !== void 0 ? productToken : "", _object_spread({
        initialData: function() {
            var _prefetched_product;
            var prefetched = readBundledData("product_page", {
                keep: true
            });
            if (productToken === (prefetched === null || prefetched === void 0 ? void 0 : (_prefetched_product = prefetched.product) === null || _prefetched_product === void 0 ? void 0 : _prefetched_product.token)) {
                return prefetched;
            }
            return undefined;
        },
        enabled: !!productToken,
        staleTime: FIVE_MINUTES_IN_MS,
        refetchOnMount: false
    }, options));
};
export var prefetchLeanProduct = function(queryClient, productToken) {
    queryClient.prefetchQuery({
        queryKey: getQueryKey(productToken),
        queryFn: getQueryFn(productToken)
    });
};
